/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_StatusInputs */

const en_roster_status = /** @type {(inputs: Roster_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_roster_status = /** @type {(inputs: Roster_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fr_roster_status = /** @type {(inputs: Roster_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_roster_status = /** @type {(inputs: Roster_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const id_roster_status = /** @type {(inputs: Roster_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const ja_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const zh_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const ar_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const it_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const ru_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const pt_roster_status = en_roster_status;

/** @type {(inputs: Roster_StatusInputs) => LocalizedString} */
const ko_roster_status = en_roster_status;

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Roster_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_status = /** @type {((inputs?: Roster_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_status(inputs)
	if (locale === "es") return es_roster_status(inputs)
	if (locale === "fr") return fr_roster_status(inputs)
	if (locale === "de") return de_roster_status(inputs)
	if (locale === "ja") return ja_roster_status(inputs)
	if (locale === "zh") return zh_roster_status(inputs)
	if (locale === "ar") return ar_roster_status(inputs)
	if (locale === "id") return id_roster_status(inputs)
	if (locale === "it") return it_roster_status(inputs)
	if (locale === "ru") return ru_roster_status(inputs)
	if (locale === "pt") return pt_roster_status(inputs)
	return ko_roster_status(inputs)
});